// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");

var procName = "MM_wrk_FindParens";

function beginFindParens(ctx, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, /* FindParens */{
        ctx: ctx
      }, (function (resp, sendToWorker, endWorkerInteraction) {
          if (resp.TAG === /* FindParensProgress */0) {
            return Curry._1(onProgress, resp.pct);
          }
          Curry._1(endWorkerInteraction, undefined);
          Curry._1(onDone, resp.parens);
        }), undefined, undefined);
}

function processOnWorkerSide(req, sendToClient) {
  var ctx = req.ctx;
  Curry._1(sendToClient, {
        TAG: /* FindParensDone */1,
        parens: MM_context.ctxIntsToStrExn(ctx, MM_context.findParentheses(ctx, (function (pct) {
                    Curry._1(sendToClient, {
                          TAG: /* FindParensProgress */0,
                          pct: pct
                        });
                  }), undefined))
      });
}

exports.procName = procName;
exports.beginFindParens = beginFindParens;
exports.processOnWorkerSide = processOnWorkerSide;
/* MM_context Not a pure module */
